import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { UserTypeModel } from '../model/user-type.model';

@Injectable()
export class UserTypeService {

  path = '/user-type';

  constructor(private baseService: BaseService) {
  }

  getPaginated(init: number, end: number, name?: string) {
    return this.baseService.get(this.path, '', { init, end, name });
  }

  getFilteredPaginated(init: number, end: number, name?: string) {
    return this.baseService.get(this.path, '/filtered', { init, end, name });
  }

  post(userType: UserTypeModel) {
    return this.baseService.post(this.path, '/', userType);
  }

  put(userType: UserTypeModel) {
    return this.baseService.put(this.path, '/', userType);
  }

  delete(idUserType: number) {
    return this.baseService.delete(this.path, '/' + idUserType);
  }

  save(userType: UserTypeModel) {
    if (userType.id) {
      return this.put(userType);
    } else {
      return this.post(userType);
    }
  }

}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/service/user-type.service.ts